import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

interface GameStatisticWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

export const setGameStatisticWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            &::before {
                background-color: ${theme.star.casino.gameInfo.borderColor};
                bottom: 30%;
                top: 30%;
            }
        `;
    }
    return css`
        &::before {
            background-color: ${theme.star.casino.gameInfo.bgColorTertiary};
            bottom: 20%;
            top: 20%;
        }
    `;
};

export const GameStatisticWrapper = withConfig(theme => styled('div', { label: 'GameStatisticWrapper' })<GameStatisticWrapperPropsType>`
    ${({ variant }): SerializedStyles => setGameStatisticWrapper(variant, theme)}
    flex-grow: 1;
    position: relative;
    &::before {
        content: '';
        margin: auto;
        position: absolute;
        right: 0;
        width: 1px;
    }
    &:last-child::before {
        content: none;
    }
`);

export const GameStatisticLabel = withConfig(theme => styled('div', { label: 'GameStatisticLabel' })`
    text-align: center;
    width: 100%;
    color: ${theme.star.casino.gameInfo.txtColorQuinary};
`);

export const GameStatisticValue = withConfig(theme => styled('div', { label: 'GameStatisticValue' })`
    color: ${theme.star.casino.gameInfo.txtColorSecondary};
    font-size: ${theme.star.fontSize.xRegular};
    font-weight: ${theme.star.fontWeight.bold};
    text-align: center;
    width: 100%;
`);
